import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'splitCamelCaseTitle',
    standalone: false
})
export class SplitCamelCaseTitlePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    // Insert space before all caps and capitalize first letter
    const result = value.replace(/([a-z])([A-Z])/g, '$1 $2');
    return result.charAt(0).toUpperCase() + result.slice(1);
  }
}
